import { render, staticRenderFns } from "./dendabunga.vue?vue&type=template&id=79e16dc1&"
import script from "./dendabunga.vue?vue&type=script&lang=js&"
export * from "./dendabunga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports